<template>
  <div class="banners-wrapper">
    <div class="flight-banner" @click="redirectToFlightsOffer">
      <div class="carousel-container">
        <div
          class="carousel-track"
          :style="{ transform: `translateX(-${currentImageIndex * 100}%)` }"
        >
          <img
            v-for="(img, index) in images"
            :key="index"
            :src="img"
            alt="Ofertas de Vuelos"
            class="banner-image"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const isMobile = ref(false);

const images = computed(() => {
  return isMobile.value
    ? [
        require("@/assets/images/BsearchFlight-600.svg"),
        require("@/assets/images/BsearchFlight-600.svg"),
      ]
    : [
        require("@/assets/images/BsearchFlight-1200.svg"),
        require("@/assets/images/BsearchFlight-1200.svg"),
      ];
});

const currentImageIndex = ref(0);
let carouselInterval;

const redirectToFlightsOffer = () => {
  router.push("/flights"); // Redirige a la página principal de vuelos
};

const handleResize = () => {
  isMobile.value = window.innerWidth <= 600;
};

onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
  carouselInterval = setInterval(() => {
    currentImageIndex.value =
      (currentImageIndex.value + 1) % images.value.length;
  }, 5000); // Cambia la imagen cada 5 segundos
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  clearInterval(carouselInterval);
});
</script>

<style scoped>
.banners-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.flight-banner {
  cursor: pointer;
}
.carousel-container {
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}
.carousel-track {
  display: flex;
  width: 100%;
  transition: transform 0.5s ease-in-out;
}
.banner-image {
  width: 100%;
  flex-shrink: 0;
  display: block;
  border-radius: 10px;
}
</style>
